import React from "react";

// api
import './api/api.js';

// react-router-dom
import {Routes, Route} from 'react-router-dom';

// pages
import Landing from "./Pages/Landing/Landing";

function App() {
  return (
    <Routes>
      <Route onUpdate={() => window.scrollIntoView({align: {top: 0}})} index path="/" element={<Landing />} />
    </Routes>
  );
}

export default App;
